module.exports = __webpack_public_path__ + "static/media/rm_digital_solutions.38b3ae27.jpg";